'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diff;

var _metadataSymbol = require('./metadataSymbol');

var _metadataSymbol2 = _interopRequireDefault(_metadataSymbol);

var _identityReducer = require('nanotools/lib/identityReducer');

var _identityReducer2 = _interopRequireDefault(_identityReducer);

var _reduxComponents = require('redux-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Diff algorithm to produce dynamic reducers.
function diff(typeMap, metadata) {
  var _this = this;

  var k;
  var componentMap = this.componentMap,
      reducerMap = this.reducerMap;

  if (!metadata) return;

  if (this.__reentrancyGuard) throw new Error("Reentrant modification of a ComponentMap instance was detected.");
  this.__reentrancyGuard = true;

  // Step 1: Determine which components were removed or added.
  var removed = [],
      added = [];
  for (k in componentMap) {
    if (!(k in metadata) && k !== _metadataSymbol2.default) removed.push(k);
  }
  for (k in metadata) {
    if (!(k in componentMap) && k !== _metadataSymbol2.default) added.push(k);
  }
  // no-op check
  if (added.length === 0 && removed.length === 0) {
    delete this.__reentrancyGuard;
    return;
  }
  // Step 2:
  // Don't delete the `removed` nodes from the state tree yet, because we haven't called `willUnmount` on them.
  // Wrinkle: `willUnmount` is allowed to dispatch actions which the reducer will see.
  // So: Mount a *temporary* reducer using `combineReducers()` but with the identity attached at each `added` node.
  // However, We only need the temporary reducer if some nodes were both added AND removed.
  if (added.length > 0 && removed.length > 0) {
    added.forEach(function (k) {
      return reducerMap[k] = _identityReducer2.default;
    });
    this.updateReducer();
  }
  // Step 3: Unmount removed nodes, then delete them from internal data structures
  if (removed.length > 0) {
    removed.forEach(function (k) {
      return componentMap[k].__willUnmount();
    });
    removed.forEach(function (k) {
      delete reducerMap[k];delete componentMap[k];
    });
  }
  // # Step 4: Instantiate the added components
  added.forEach(function (k) {
    var componentDescriptor = typeMap(metadata[k]);
    if (!componentDescriptor) {
      throw new Error('ComponentMap: typeMap entry not found for ComponentMap entry with key ' + k);
    }
    componentMap[k] = (0, _reduxComponents.createComponent)(componentDescriptor);
  });
  // # Step 5: willMount the added components
  added.forEach(function (k) {
    var nextPath = _this.path.slice();
    nextPath.push(k);
    componentMap[k].__willMount(_this.store, nextPath, _this);
  });
  // # Step 6: Build the "real" reducer out of the reducers of all the components that now exist.
  for (k in componentMap) {
    reducerMap[k] = componentMap[k].reducer;
  }
  this.updateReducer(removed.length > 0);
  // # Step 7: Run didMount on the added components
  added.forEach(function (k) {
    return componentMap[k].__didMount();
  });

  delete this.__reentrancyGuard;
}